<template>
  <svg width="28" height="28" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12.8564" r="12" fill="#F9F9F9"/>
<path d="M11.8571 7.71387C9.01713 7.71387 6.71429 10.0167 6.71429 12.8567H5L7.28571 15.1424L9.57144 12.8567H7.85715C7.85715 10.6482 9.64858 8.85673 11.8571 8.85673C14.0657 8.85673 15.8571 10.6482 15.8571 12.8567C15.8571 15.0653 14.0657 16.8567 11.8571 16.8567C10.9914 16.8567 10.1943 16.5796 9.53715 16.111L8.72857 16.931C9.59715 17.5996 10.68 17.9996 11.8571 17.9996C14.6972 17.9996 17 15.6967 17 12.8567C17 10.0167 14.6972 7.71387 11.8571 7.71387Z" fill="#B8CDD7"/>
<path d="M12.9996 12.8567C12.9996 12.2253 12.4882 11.7139 11.8567 11.7139C11.2253 11.7139 10.7139 12.2253 10.7139 12.8567C10.7139 13.4882 11.2253 13.9996 11.8567 13.9996C12.4882 13.9996 12.9996 13.4882 12.9996 12.8567Z" fill="#B8CDD7"/>
</svg>

</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
svg {
    cursor: pointer;
    circle, path {
        transition: all 0.2s ease;
    }
    &:hover {
        circle {
            fill: #B8CDD7;
        }
        path {
            fill: #F9F9F9;
        }
    }
}
</style>